export class CriteriaType {
  static readonly MSISDN  = new CriteriaType('MSISDN', 'Msisdn','mdi-phone');
  static readonly USER_ID = new CriteriaType('USER ID', 'User ID','mdi-account');
  static readonly EMAIL  = new CriteriaType('EMAIL', 'Email','mdi-email');
  static readonly PAYPAL_PAYER_ID  = new CriteriaType('PAYPAL_PAYER_ID', 'Paypal Payer Id','mdi-credit-card');
  static readonly CREDIT_CARD_TOKEN  = new CriteriaType('CREDIT_CARD_TOKEN', 'Credit Card Token','mdi-credit-card');
  static readonly FRAUD_CASE_ID  = new CriteriaType('FRAUD_CASE_ID', 'Fraud Case Id','mdi-numeric');
  static readonly TRANSACTION_ID  = new CriteriaType('TRANSACTION_ID', 'Transaction Id','mdi-numeric');


  // private to disallow creating other instances of this type
  private constructor(public readonly key: string, public readonly text: any, public readonly icon: any) {
  }

  toString() {
    return this.key;
  }
}

export class FilterCriteria
{
  type = CriteriaType.MSISDN
  value = ''
  icon = ''

  constructor(type: CriteriaType, value: string) {
    this.value = value;
    this.type = type;
  }
}
